// extracted by mini-css-extract-plugin
export var aggregationCell = "_2w-t";
export var aggregationRow = "_2w-s";
export var borderlessSpinnerContainer = "_2w-3";
export var cardLayout = "_2w-6";
export var cardLayoutNoFooter = "_2w-a";
export var cardLayoutPageControl = "_2w-9";
export var cardLayoutWithFooter = "_2w-8";
export var closeIcon = "_2w-l";
export var columnHeaderSurface = "_2w-d";
export var columnHeaderSurfaceDragOverlay = "_2w-11";
export var columnHeaderSurfaceResizing = "_2w-y";
export var contextMenuAnchor = "_2w-1";
export var draggableColumnHeader = "_2w-z";
export var draggableColumnHeaderOverlay = "_2w-10";
export var expandIcon = "_2w-m";
export var expanded = "_2w-n";
export var filterBackIcon = "_2w-g";
export var filterButtonAnchor = "_2w-f";
export var filterDropdown = "_2w-o";
export var filterDropdownDivider = "_2w-j";
export var filterDropdownHeader = "_2w-r";
export var filterDropdownItem = "_2w-q";
export var filterDropdownModal = "_2w-p _2w-o";
export var filterItem = "_2w-e";
export var normalCellWithAdjustableBorder = "_2w-k";
export var pinButtonContainer = "_2w-u";
export var pinIcon = "_2w-v";
export var pinIconActive = "_2w-w";
export var spinner = "_2w-0";
export var spinnerContainer = "_2w-2";
export var subFilterArrowIcon = "_2w-h";
export var tableContainer = "_2w-4";
export var tableContentDraggingColumns = "_2w-c";
export var tableContentInner = "_2w-7";
export var tableContentInnerFill = "_2w-b";
export var tableContentWrapper = "_2w-5";
export var toolbarEnd = "_2w-i";
export var viewButtonContainer = "_2w-x";